// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2vSJQ","validationTips":"StatementDescriptor_validationTips__3reRG"};